import React from 'react';
import {
  ListItemIcon,
  ListItemText,
  Menu,
} from '@mui/material';
import { ArchiveOutlined as ArchiveOutlinedIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';

import { DangerMenuItem, MenuItemLabel } from './styles';
import texts from './text.json';

/*
 * Inside Sales categories are assigned from the Inside Sales Offerings section on this page, which
 * shows every category and what holds it, so this menu no longer carries a category picker of its
 * own — two places to set the same field only invited them to disagree.
 */
const PackageMenu = ({
  menuState,
  onClose,
  onArchive,
}) => (
  <Menu
    anchorEl={menuState?.anchorEl}
    open={!!menuState}
    onClose={onClose}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
  >
    <DangerMenuItem onClick={onArchive}>
      <ListItemIcon><ArchiveOutlinedIcon fontSize="small" /></ListItemIcon>
      <ListItemText
        primary={<MenuItemLabel>{menuState?.pkg?.isArchived ? texts.unarchive : texts.archive}</MenuItemLabel>}
      />
    </DangerMenuItem>
  </Menu>
);

PackageMenu.propTypes = {
  menuState: PropTypes.shape({
    anchorEl: PropTypes.object,
    pkg: PropTypes.object,
  }),
  onClose: PropTypes.func.isRequired,
  onArchive: PropTypes.func.isRequired,
};

PackageMenu.defaultProps = {
  menuState: null,
};

export default PackageMenu;
